import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Proteccion_especiales } from 'src/app/models/protecciones-especiales.model';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-porcentajes-obra-nueva',
  templateUrl: './porcentajes-obra-nueva.component.html',
  styleUrls: ['./porcentajes-obra-nueva.component.css']
})
export class PorcentajesObraNuevaComponent {

  public rows = [];
  public actualRow;
  public porcentajes_obr: Proteccion_especiales;
  public form;
  public valor;
  public formulario;
  public num;


  constructor(private _changeDetectionRef: ChangeDetectorRef,) {
    this.formulario = localStorage.getItem("form")


    if (this.formulario == "1-1.1") {
      this.num = '6.6';
    }

    this.form = new FormGroup({
      proy_densidad: new FormControl(''),
      densidad_ocupacion: new FormControl(''),
      porcentaje_cesion: new FormControl(''),
    })

    if (!JSON.parse(localStorage.getItem("porcentajes_obr"))) {
      localStorage.setItem("porcentajes_obr", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("porcentajes_obr"));

      this.form.controls['densidad_ocupacion'].setValue(this.rows[0] ? this.rows[0].densidad_ocupacion : '')
      this.valor = (this.form.value.densidad_ocupacion * 11) / 2000
      this.form.value.porcentaje_cesion = this.valor + "%"
      this.form.controls['porcentaje_cesion'].setValue(this.valor ? this.valor : '')

      if (this.rows[0] && this.rows[0].proy_densidad == "CON DENSIDAD DE OCUPACIÓN HASTA 8.000 Personas/Hectárea") {
        this.form.controls['proy_densidad'].setValue('1')
      }
      if (this.rows[0] && this.rows[0].proy_densidad == "CON DENSIDAD DE OCUPACIÓN SOBRE 8.000 Personas/Hectárea") {
        this.form.controls['proy_densidad'].setValue('2')
      }
    }

  }

  add_porcentajes() {

    if (this.form.value.proy_densidad == "1") {
      this.valor = (this.form.value.densidad_ocupacion * 11) / 2000
      this.form.value.porcentaje_cesion = this.valor + "%"
      this.form.controls['porcentaje_cesion'].setValue(this.valor ? this.valor : '')

      this._changeDetectionRef.detectChanges();


      localStorage.setItem("porcentajes_obr", JSON.stringify([]));
      this.actualRow = localStorage.getItem("porcentajes_obr");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        proy_densidad: "CON DENSIDAD DE OCUPACIÓN HASTA 8.000 Personas/Hectárea",
        densidad_ocupacion: this.form.value.densidad_ocupacion,
        porcentaje_cesion: this.form.value.porcentaje_cesion

      })
      localStorage.setItem("porcentajes_obr", JSON.stringify(this.rows));
    }

    if (this.form.value.proy_densidad == "2") {
      this.valor = "44%"


      localStorage.setItem("porcentajes_obr", JSON.stringify([]));
      this.actualRow = localStorage.getItem("porcentajes_obr");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        proy_densidad: "CON DENSIDAD DE OCUPACIÓN SOBRE 8.000 Personas/Hectárea",
        densidad_ocupacion: "",
        porcentaje_cesion: "44%"

      })
      localStorage.setItem("porcentajes_obr", JSON.stringify(this.rows));
    }
  }

  delete_normas(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("porcentajes_obr", JSON.stringify(this.rows));
      }
    }
  }

}
